import { render } from "./Langages.vue?vue&type=template&id=3473d03a"
import script from "./Langages.vue?vue&type=script&lang=js"
export * from "./Langages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__